import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { PACKAGE_SERVICE_NAME, PACKAGE_CONTENT_SERVICE_NAME, PACKAGE_RELATED_ORDERS_SERVICE_NAME, PackageService, PackageContentService, PackageRelatedOrdersService, } from '../../../services/package'
import { SYSTEM_SERVICE_NAME, SystemService, $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { PackageDirectiveController } from './packages-details.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './packages-details.tpl.html'

//#endregion

// Setup


export class PackageDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        PACKAGE_SERVICE_NAME,
        PACKAGE_CONTENT_SERVICE_NAME,
        PACKAGE_RELATED_ORDERS_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            packageService: PackageService,
            packageContentService: PackageContentService,
            packageRelatedOrdersService: PackageRelatedOrdersService,
            systemService: SystemService
        ) => new PackageDirectiveController(
            $scope,
            $q,
            $timeout,
            logger,
            localDictionary,
            userSession,
            packageService,
            packageContentService,
            packageRelatedOrdersService,
            systemService,
            PackageService.REFERENCE_TYPE,
            PackageService.SIMAX_MODULE_NAME
        )]
    controllerAs = '$ctrl'

    template = TEMPLATE
}

// Setup End